export const INITIAL_STATE_PURCHASE_MOVIMENT = {
  id: "",
  idEmpresa: "",
  idProduto: "",
  idCompra: "",
  quantidade: 1,
  valorUnitario: 0,
  tipoProduto: "normal",
  agrotoxico: {
    idAgrotoxico: null,
    registroAgrotox: null,
    agrotoxico: null,
    idEmbalagem: null,
    embalagem: null,
    lote: null,
  },
}

export const INVALID_FIELDS_PURCHASE_MOVIMENT = {
  idProduto: "",
  idCompra: "",
  quantidade: "",
  valorUnitario: "",
  tipoProduto: "",
  idAgrotoxico: "",
  idEmbalagem: "",
  registroAgrotox: ""
}